import { settings } from '../settings';
import Fetch from '../utils/fetch';
import { OrderParcels } from 'types/orderTypes';

export async function fetchParcelByOrderID(
  orderIds: string[]
): Promise<OrderParcels[]> {
  const response = await Fetch.post({
    url: `${settings.newApiUrl}/parcel/`,
    body: {
      orderIds: orderIds,
    },
  });

  if (response.ok) {
    return await response.json();
  } else {
    return [];
  }
}
